import {doStyleSidebarFilters} from "../blocks/sidebar-filters";
import {TranslationsManager} from "../utils/localisationManager";

export class ClientsPages {
    // static EventListeners = {
    //     'ShoptetDOMPageContentLoaded': ClientsPages.doLoadOnShoptetDOMPageContentLoaded,
    // }
    // static doLoadOnShoptetDOMPageContentLoaded() {}
    // static doLoadOnShoptetDOMPageMoreProductsLoaded() {}
    // static doLoadOnShoptetDOMContentLoaded() {}
    // static doLoadOnChange() {}
    static async doInit() {
        ClientsPages.doStyleMisc();
        doStyleSidebarFilters();
        return true;
    }

    static doStyleMisc() {
        $('body').addClass('in-client-page');
        $('.in-client-page .sidebar-inner ul li.logout').insertAfter('.in-client-page .sidebar-inner ul li:last-child');
        $(`<h4>${TranslationsManager.doGetStringByLang('CLIENT_PAGE_MY_ACCOUNT')}</h4>`).prependTo('.in-client-page .sidebar-inner .client-center-box');
        $('aside .client-center-box').addClass('box-categories');

        $('.in-client-page .sidebar-inner ul li a:contains("Moje osobní údaje")').text(`${TranslationsManager.doGetStringByLang('CLIENT_PAGE_MY_DETAILS')}`);
        $('.in-client-page .sidebar-inner ul li a:contains("Moje objednávky")').text(`${TranslationsManager.doGetStringByLang('CLIENT_PAGE_MY_ORDERS')}`);
        $('.in-client-page .sidebar-inner ul li a:contains("Moje doklady")').text(`${TranslationsManager.doGetStringByLang('CLIENT_PAGE_MY_CARDS')}`);
        $('.in-client-page .sidebar-inner ul li a:contains("Moje slevy")').text(`${TranslationsManager.doGetStringByLang('CLIENT_PAGE_MY_DISCOUNTS')}`);
        $('.in-client-page .sidebar-inner ul li a:contains("Moje hodnocení u produktů")').text(`${TranslationsManager.doGetStringByLang('CLIENT_PAGE_MY_PRODUCT_RATING')}`);
        $('.in-client-page .sidebar-inner ul li a:contains("Moje diskuze u produktů")').text(`${TranslationsManager.doGetStringByLang('CLIENT_PAGE_MY_DISCUSSION')}`);
        // $('aside ul li.logout').insertAfter('aside ul li:last-child');
        // $('aside ul li a[href="/klient/klient-diskuze/"]').parent().addClass('hidden');
        // $('.content-inner > h1').prependTo('.content-wrapper-in');
    }
}
